import { type weeklyreportHourRow } from '../../services/api/weekly-report';
import { numberFormat } from '../../pages/weeklyreport/format';

interface HourHistogramProps {
  rows: weeklyreportHourRow[];
  busiestHour: number;
}

export const HourHistogram = ({ rows, busiestHour }: HourHistogramProps) => (
  <>
    <div className="relative flex h-48 items-end gap-1">
      <div className="pointer-events-none absolute inset-0 flex flex-col justify-between">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="border-t border-slate-100" />
        ))}
      </div>
      {rows.map((row) => (
        <div key={row.hour} className="group relative flex h-full flex-1 flex-col justify-end">
          <div className="pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 hidden -translate-x-1/2 whitespace-nowrap rounded bg-slate-800 px-2 py-1 text-xs text-white shadow-lg group-hover:block">
            kl {row.hour}: {numberFormat.format(row.count)} chattar
          </div>
          <div
            className="w-full rounded-t bg-brand-blue transition group-hover:bg-brand-secondary-blue"
            style={{
              height: `${(row.count / busiestHour) * 100}%`,
              minHeight: row.count > 0 ? '2px' : '0',
            }}
          />
        </div>
      ))}
    </div>
    <div className="mt-1 flex gap-1">
      {rows.map((row) => (
        <span key={row.hour} className="flex-1 text-center text-[10px] text-slate-400">
          {row.hour % 3 === 0 ? row.hour : ''}
        </span>
      ))}
    </div>
    <p className="mt-2 text-xs text-slate-500">Svensk tid</p>
  </>
);
